import React, {useEffect, useState} from 'react';
import {getProduct} from "../../products/api/ProductsAPI";
import {showError, showSuccess} from "../../../utils/toastHelper";
import {useNavigate, useParams} from "react-router-dom";
import Loading from "../../../layouts/Loading";
import Header from "../../../layouts/Header";
import {GiTwoCoins} from "react-icons/gi";
import {CiEdit} from "react-icons/ci";
import {LiaCubesSolid} from "react-icons/lia";
import {TbArrowBadgeLeft} from "react-icons/tb";
import { storeTicket} from "../api/OrdersAPI";
const currencyFormat = Intl.NumberFormat('en-US');

const StoreTicket = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    const [product, setProduct] = React.useState([]);
    const [loading, setLoading] = useState(true);
    const [count, setCount] = useState(1);
    const [message, setMessage] = useState('');
    const [vendor, setVendor] = useState(window.localStorage.getItem('_vid' ));
    const config = window.APP_CONFIG;

    useEffect(() => {

        const fetchProduct = async () => {
            try {
                const params = {
                    vendor,
                    list: 1
                }
                const data = await getProduct(id, params);
                setProduct(data?.data || []);
                setTimeout(() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                }, 400)
            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchProduct();
    }, [id]);


    const onStoreTicket = async () => {

        setLoading(true);
        try {

            const request = {
                title : 'درخواست پیش فاکتور ' + product.name,
                message,
                count,
                product : id,
                vendor,
            }
            const result = await storeTicket(request);
            showSuccess(result.message );
            setTimeout(() => {
                window.location.assign(`/factors`);
            }, 1000)

        } catch (err) {
            showError(err);
        } finally {
            setLoading(false);
        }




    }

    if (loading) return <Loading/>;


    return (
        <React.Fragment>
            <Header hasBack={true} transparent={false} title='ثبت درخواست پیش فاکتور'/>

            <section className='container mt-5 pt-2 mobile-size-option'>
                <div className="row my-2 product-search-card  mx-2 pt-2 px-0 "

                >
                    <div className="col-3  pb-3 border-bottom "
                         onClick={
                             () => {
                                 navigate(`/product/${product.id}`)

                             }
                         }
                    >
                        <img src={product.image} alt={product.name} className='product-img'/>
                    </div>
                    <div className="col-9 fw-bolder text-muted pb-3 border-bottom ">

                        {product.name}
                        {product.vendor_price?.discounted_price ?
                            <div className='price-with-discount mt-3'>

                                <GiTwoCoins className='ms-2 '/>
                                {
                                    product.vendor_price?.discount_percent > 0 &&
                                    <span
                                        className='text-decoration-line-through fw-normal text-small-2 px-2 '>
                                                       {currencyFormat.format(product.vendor_price?.price)}
                                        &nbsp;
                                         {config.currency}
                                            </span>
                                }
                                {currencyFormat.format(product.vendor_price?.discounted_price)}
                                &nbsp;
                                 {config.currency}
                                &nbsp;

                            </div> :
                            <div className='text-small-2 text-muted'>
                                <GiTwoCoins className='mx-2'/>
                                توافقی
                            </div>
                        }
                    </div>
                    <div className="col-8 mt-3 text-small-2 pt-2">
                        <LiaCubesSolid className='mx-2'/>
                        تعداد محصول مورد درخواست
                    </div>
                    <div className="col-4 mt-3">
                        <div>

                            <input type="number" className="form-control text-center text-big-3 bg-light"
                                   id="exampleFormControlInput1"
                                   placeholder="تعداد"
                                   value={count}
                                   onChange={(e) => {
                                       setCount(e.target.value)
                                   }}
                            />
                        </div>
                    </div>


                </div>

                <div className="row  product-search-card mx-2 pt-2 px-0">
                    <div className="col-12 my-3 text-muted text-small-1">
                        <CiEdit className='mx-2'/>
                        توضیحات مد نظر خود را وارد کنید:
                    </div>
                    <div className="col-12">
                        <div className="form-floating">
                            <textarea className="form-control" rows={10} style={{height: '200px'}}
                                      placeholder="ثبت نظرات"
                                      value={message}
                                      onChange={(e) => {
                                          setMessage(e.target.value)
                                      }}
                                      id="floatingTextarea"></textarea>
                            <label className='right-0' htmlFor="floatingTextarea">توضیحات</label>
                        </div>
                    </div>
                </div>

                <div className="row mx-2 mt-3 px-0">

                    <div className="col-12  px-0 ">
                        <button
                            className="btn bg-third-color w-100 text-white  "
                            onClick={onStoreTicket}


                        >
                            ثبت درخواست
                            <span className="badge  p-2 float-start">

<TbArrowBadgeLeft className='text-big-3'/>
                    </span>
                        </button>
                    </div>
                </div>

            </section>
        </React.Fragment>
    );
};

export default StoreTicket;